import { useEffect, useState } from 'react'

import { canConfirmDropOffPoint, getSearchAddress } from '@/DeliveryMethodsPage/DropOffPointDrawer/helpers'

import useServicePoints from '../useServicePoints/useServicePoints'

const useDropOffPointDrawer = ({ show, orderId, returnId, deliveryMethod, shippingAddress, selectedDropOffPoint }) => {
  const [searchAddress, setSearchAddress] = useState({ street: '', number: '' })
  const [showUpdateAddressDrawer, setShowUpdateAddressDrawer] = useState(false)
  const [pickedDropOffPoint, setPickedDropOffPoint] = useState(selectedDropOffPoint)
  const { servicePoints, searchServicePoints, searchingServicePoints } = useServicePoints({
    orderId,
    returnId,
    deliveryMethodId: deliveryMethod?.id,
    city: shippingAddress.locality,
  })

  useEffect(() => {
    if (!show) return

    const initialAddress = { street: shippingAddress.line_1 || '', number: shippingAddress.house_number || '' }

    setSearchAddress(initialAddress)
    setPickedDropOffPoint(selectedDropOffPoint)
    searchServicePoints(getSearchAddress(initialAddress))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, shippingAddress.line_1, shippingAddress.house_number])

  const openUpdateAddressDrawer = () => setShowUpdateAddressDrawer(true)

  const closeUpdateAddressDrawer = () => setShowUpdateAddressDrawer(false)

  const updateSearchAddress = address => {
    setSearchAddress(address)
    setShowUpdateAddressDrawer(false)
    searchServicePoints(getSearchAddress(address))
  }

  return {
    searchAddress,
    showUpdateAddressDrawer,
    pickedDropOffPoint,
    dropOffPoints: servicePoints,
    searching: searchingServicePoints,
    canConfirm: canConfirmDropOffPoint({
      dropOffPoints: servicePoints,
      pickedDropOffPoint,
      searching: searchingServicePoints,
    }),
    pickDropOffPoint: setPickedDropOffPoint,
    openUpdateAddressDrawer,
    closeUpdateAddressDrawer,
    updateSearchAddress,
  }
}

export default useDropOffPointDrawer
